<ng-container *ngIf="systemDetails$ | async as systemDetails; else noDataSkeleton">
  <lib-block-title
    id="detail-title"
    [title]="labels.title">
  </lib-block-title>

  <ng-container *ngTemplateOutlet="systemDetailSection; context:{ label: labels.systemName, id: 'system-name', value: systemDetails.name }"></ng-container>
  <ng-container *ngTemplateOutlet="systemDetailSection; context:{ label: labels.systemType, id: 'system-type', value: systemDetails.type }"></ng-container>

  <ng-template
    #systemDetailSection
    let-label="label"
    let-id="id"
    let-value="value">
    <section
      class="block-bg-contrast fx-row tw-items-center fx-gap-3 min-h-8 tw-p-3"
      [id]="id">
      <div class="tw-text-sm tw-font-medium">
        {{ label }}
      </div>
      <div class="tw-text-base tw-font-normal tw-text-grey-300">
        {{ value }}
      </div>
    </section>
  </ng-template>
</ng-container>


<ng-template #noDataSkeleton>
  <ion-skeleton-text
    id="detail-title"
    class="w-42 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="system-name"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="system-phase"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="system-type"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>